module.exports = __webpack_public_path__ + "static/img/抖音广告_06.0f3b11d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/gdd102/抖音广告_06.jpg
// module id = TZwE
// module chunks = 1